module.exports = __webpack_public_path__ + "images/501.gif";